import { Enum } from 'enumify';

export default class ServiceType extends Enum {}
ServiceType.initEnum([
  'CONNECT',
  'HOME',
  'THERAPIST',
]);



// WEBPACK FOOTER //
// ./src/routes/user/ServiceType.js